export const iconFontAwesomeBuildingsBuildingCircleArrowRight = (
	<i className="fa-solid fa-building-circle-arrow-right"></i>
);
